/* nexusClient.ts */
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { getAccessToken } from '@/services/secureStorage';

// Feature flag to determine auth method
const USE_COOKIE_AUTH = process.env.VUE_APP_USE_COOKIE_AUTH === 'true';

// Use the Nexus GraphQL endpoint defined in the environment variables
const nexusHttpEndpoint = process.env.VUE_APP_NEXUS_GRAPHQL_HTTP;

const nexusHttpLink = createHttpLink({
  uri: nexusHttpEndpoint,
  credentials: 'include' // Send cookies with requests
});

// Create auth link for Nexus client
const nexusAuthLink = setContext((_, { headers }) => {
  const token = getAccessToken();

  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  };
});

const nexusClient = new ApolloClient({
  link: from([nexusAuthLink, nexusHttpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV === 'development'
});

export default nexusClient;
